export type CalendarGridDay = {
  date: Date;
  day: number;
  isCurrentMonth: boolean;
  isWeekend: boolean;
  isHoliday: boolean;
};

const sampleCzechHolidayKeys = new Set(['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26']);

function getDaysInMonth(year: number, month: number) {
  return new Date(year, month, 0).getDate();
}

function getMondayFirstDayIndex(date: Date) {
  return (date.getDay() + 6) % 7;
}

function isSampleCzechHoliday(date: Date) {
  return sampleCzechHolidayKeys.has(`${date.getMonth() + 1}-${date.getDate()}`);
}

export function getMonthGrid(year: number, month: number): CalendarGridDay[] {
  const firstDay = new Date(year, month - 1, 1);
  const leadingDays = getMondayFirstDayIndex(firstDay);
  const daysInPreviousMonth = getDaysInMonth(year, month - 1);
  const daysInCurrentMonth = getDaysInMonth(year, month);
  const grid: CalendarGridDay[] = [];

  for (let index = leadingDays - 1; index >= 0; index -= 1) {
    const date = new Date(year, month - 2, daysInPreviousMonth - index);
    grid.push({
      date,
      day: date.getDate(),
      isCurrentMonth: false,
      isWeekend: date.getDay() === 0 || date.getDay() === 6,
      isHoliday: isSampleCzechHoliday(date),
    });
  }

  for (let day = 1; day <= daysInCurrentMonth; day += 1) {
    const date = new Date(year, month - 1, day);
    grid.push({
      date,
      day,
      isCurrentMonth: true,
      isWeekend: date.getDay() === 0 || date.getDay() === 6,
      isHoliday: isSampleCzechHoliday(date),
    });
  }

  let nextMonthDay = 1;
  while (grid.length < 42) {
    const date = new Date(year, month, nextMonthDay);
    grid.push({
      date,
      day: date.getDate(),
      isCurrentMonth: false,
      isWeekend: date.getDay() === 0 || date.getDay() === 6,
      isHoliday: isSampleCzechHoliday(date),
    });
    nextMonthDay += 1;
  }

  return grid;
}
